import React from "react";
import SheetRecordsTable from "../../components/ui-custom/SheetRecordsTable";

// Purchase Orders for the logged-in customer/vendor (from Google Sheet "POs").
const Orders = () => <SheetRecordsTable endpoint="/portal/pos" />;

export default Orders;
